module.exports = __webpack_public_path__ + "img/clock-c.cb12b6a0.png";